import { Button } from "@mui/material";
import React from "react";

export const CheckedFilterButton = ({
	content = null,
	colorOption = null,
	widthOption = null,
	heigthOption = null,
}) => {
	return (
		<Button
			variant="contained"
			color="secondary"
			disableElevation
			sx={{
				// width: "3rem",
				// height: "3rem",
				width: `${widthOption}`,
				height: `${heigthOption}`,
				border: "1px solid rgb(201, 201, 201)",
				borderRadius: "50px",
				minWidth: "0",
			}}
			style={{
				color:
					colorOption && `#${colorOption}` !== "#000000"
						? "#292929"
						: "#FAFAFA",
				backgroundColor: `#${colorOption}`,
			}}
		>
			{content}
		</Button>
	);
};
